import type { V10QueueCard } from "../adapters/v10-fixtures.js";
import { humanV10QueueRiskLabel } from "../adapters/v10-queue-risk.js";

export function V10QueueCardView({
  card,
  onAction,
}: {
  readonly card: V10QueueCard;
  readonly onAction: (card: V10QueueCard) => void;
}) {
  return (
    <article className="v10-queue-card">
      <div>
        <strong>{card.clientName}</strong>
        <p>{card.happened}</p>
        <p className="v10-muted">{card.blocked}</p>
        <p className="v10-muted" data-testid="v10-queue-owner">
          Owner: {card.ownerLabel}
        </p>
        <p className="v10-muted" data-testid="v10-queue-risk">
          {humanV10QueueRiskLabel(card.riskLevel)}
        </p>
        <span className="v10-age">{card.ageLabel}</span>
      </div>
      <button type="button" className="v10-btn v10-btn--primary" onClick={() => onAction(card)}>
        {card.ctaLabel}
      </button>
    </article>
  );
}

export function V10QueueSection({
  title,
  cards,
  onAction,
}: {
  readonly title: string;
  readonly cards: readonly V10QueueCard[];
  readonly onAction: (card: V10QueueCard) => void;
}) {
  if (cards.length === 0) return null;
  return (
    <section className="v10-queue-section" aria-label={title}>
      <h2>{title}</h2>
      <div className="v10-queue-list">
        {cards.map((card) => (
          <V10QueueCardView key={card.id} card={card} onAction={onAction} />
        ))}
      </div>
    </section>
  );
}
